module.exports = __webpack_public_path__ + "assets/img/17.fw.db3830a8.png";